import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWebsite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"website, webbuilder, coding"} maskId="square-filled-radius-0-stroke-1-IconWebsite"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V7H21V21ZM6.79297 14L10.1465 17.3535L10.8535 16.6465L8.20703 14L10.8535 11.3535L10.1465 10.6465L6.79297 14ZM13.1465 11.3535L15.793 14L13.1465 16.6465L13.8535 17.3535L17.207 14L13.8535 10.6465L13.1465 11.3535Z" fill="currentColor"/><path d="M21 6H3V3H21V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWebsite;
